// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';
import CSSTransition from 'react-transition-group/CSSTransition';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';

import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';

import './SearchAreaButton.less';

export type SearchAreaButtonProps = {
    isVisible: boolean,
    onClick: Function,
    shouldDisableSearchButton: boolean,
    isLoading: boolean
};

function onClickHandler(onClick) {
    return function onClickPropHandler() {
        trigger(GENERIC_EVENT, {
            eventcategory: 'search',
            eventaction: 'map search button click'
        });
        onClick();
    };
}

const SearchAreaButton = ({
    isVisible,
    onClick,
    shouldDisableSearchButton,
    isLoading
}: SearchAreaButtonProps) => (
    <div>
        <CSSTransition
            in={isVisible}
            classNames="Map__searchArea__transition"
            timeout={400}
            mountOnEnter
            unmountOnExit
        >
            <div className="Map__search" data-wdio="Map__search">
                <button
                    key="searchareaShow"
                    type="button"
                    className="btn btn-primary"
                    onClick={onClickHandler(onClick)}
                    data-wdio="Map__search"
                    disabled={shouldDisableSearchButton}
                >
                    <FormattedMessage
                        id="searchThisArea"
                        description="Search this area"
                        defaultMessage="Search this area"
                    />
                </button>
            </div>
        </CSSTransition>
        <LoadingOverlay loading={isLoading} />
    </div>
);

export default SearchAreaButton;
